import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseResource } from '../../core/abstractions/base.resource';
import { ApiResponseModel } from '../../models/core/api-response.model';
import { AuthRequestModel } from '../../models/core/auth-request.model';
import { AuthResponseModel } from '../../models/core/auth-response.model';
import { ResourceConfig } from '../../models/core/resource.config';

@Injectable({
    providedIn: 'root'
})
export class AuthResource extends BaseResource {
    constructor() {
        super(new ResourceConfig({ baseController: 'auth' }));
    }

    login(data: AuthRequestModel): Observable<ApiResponseModel<AuthResponseModel>> {
        return this._requestService.makePost<ApiResponseModel<AuthResponseModel>>(this.getUrl(''), data);
    }

    authCheck(): Observable<any> {
        return this._requestService.makeGet<any>(this.getUrl(''));
    }
}
